import { FETCH_DATA_REQUEST, FETCH_DATE_CONFIG, SET_REVENUE_DATE, DISPLAY_ERROR_MESSAGE, SET_SHOW_INSTRUCTION_MODEL, 
        SET_CHANGE_REQUEST_NUMBER, RESET_SUBMITTED_AND_ERROR_FLAGS, DATE_CHANGE_FLAG, DATE_CHANGED, 
        FETCH_STATUS_WISE_REVENUE_DATES, SET_REVENUE_DATA_LOADING_FLAG, SET_UNBLOCK_FROM_DATE_AND_CONTRACT_CODE,
    SET_WEEKLY_START_DATE, SET_WEEKLY_END_DATE, WEEKLY_DATE_CHANGE_FLAG, SET_RAW_DATE_HANDLER, SET_RAW_DATE
    } from './actionTypes';

export const revenueCalendarReducer = (state, action) => {
    switch(action.type) {
        case FETCH_DATA_REQUEST : 
            return {
                ...state,
                isLoading: action.payload.isLoading,
                isError: action.payload.isError,
                errorMessage: action.payload.errorMessage,
                showInstructions: false, 
                modelHeaderTitle: "",
                isSuccessfulSubmitted: false,
                isFileImportedSuccessfully:false,
                showModel: false,
                requestStatus: 0
            } 
        case FETCH_DATE_CONFIG : 
            return { 
                ...state, 
                revenueDate: action.payload.revenueDate,
                minDate: action.payload.minDate,
                maxDate: action.payload.maxDate,
                weeklyStartDate: action.payload.weeklyStartDate,
                weeklyEndDate: action.payload.weeklyEndDate,
                sessionTimeoutLimit: action.payload.sessionTimeoutLimit,
                idleTimeoutLimit: action.payload.idleTimeoutLimit,
                isLoading: action.payload.isLoading,
                requestStatus: 0
            };
        case SET_REVENUE_DATE: 
            return {
                ...state,
                isDateChangeFlag : false,
                revenueDate: action.payload.revenueDate
            }    
        case RESET_SUBMITTED_AND_ERROR_FLAGS :  
            return {
                ...state,
                isLoading: false, 
                isError: false, 
                errorMessage: "", 
                isSuccessfulSubmitted: false, 
                showModel: false,
                showInstructions: false, 
                modelHeaderTitle: "",
                isFileImportedSuccessfully: false,
                changeReqNumber: null,
                requestStatus: 0,
                isMonthlyRevenueSubmitted: false,
                contractCodeList: null
            }
        case SET_SHOW_INSTRUCTION_MODEL : {
            return {
                ...state,
                showModel: action.payload.showModel,
                showInstructions: action.payload.showInstructions,
                modelHeaderTitle: action.payload.modelHeaderTitle,
                requestStatus: 0,
                isError: false, 
                isSuccessfulSubmitted: false
            }
        }    
        case DATE_CHANGE_FLAG:
            return {
                ...state,
                isDateChangeFlag: true,
                newSelectedDate : action.payload.newSelectedDate,
                oldSelectedDate : action.payload.oldSelectedDate
            }
        case DATE_CHANGED: 
            return {
                ...state,
                isDateChanged: action.payload.isDateChanged
            } 
        case FETCH_STATUS_WISE_REVENUE_DATES: 
            return {
                ...state,
                statusWiseRevenueDates: action.payload.statusWiseRevenueDates
            } 
        case DISPLAY_ERROR_MESSAGE: 
            return {
                ...state,
                isLoading: action.payload.isLoading,
                isError: action.payload.isError,
                errorMessage: action.payload.errorMessage,
                showModel: action.payload.showModel,
                modelHeaderTitle: action.payload.modelHeaderTitle,
                isFileImportedSuccessfully: action.payload.isFileImportedSuccessfully,
                isSuccessfulSubmitted: action.payload.isSuccessfulSubmitted,
                requestStatus: action.payload.requestStatus,
                isMonthlyRevenueSubmitted: action.payload.isMonthlyRevenueSubmitted,
                contractCodeList: action.payload.contractCodeList
            }     
        case SET_CHANGE_REQUEST_NUMBER:
            return{
                ...state,
                changeReqNumber : action.payload.changeReqNumber
            } 
        case SET_UNBLOCK_FROM_DATE_AND_CONTRACT_CODE:
            return {
                ...state,
                unblockFromDate : action.payload.unblockFromDate,
                selectedContractCodeValue: action.payload.selectedContractCodeValue
            }    
        case SET_REVENUE_DATA_LOADING_FLAG: 
            return {
                ...state,
                dataLoading: action.payload.dataLoading
            }  
        case SET_WEEKLY_START_DATE:
            return {
                ...state,
                isDateChangeFlag: false,
                weeklyStartDate: action.payload.weeklyStartDate
            }   
        case SET_WEEKLY_END_DATE:
            return {
                ...state,
                isDateChangeFlag: false,
                weeklyEndDate: action.payload.weeklyEndDate
            }  
        case WEEKLY_DATE_CHANGE_FLAG:
            return {
                ...state,
                isDateChangeFlag: true,
                newWeeklyStartDate : action.payload.newWeeklyStartDate,
                oldWeeklyStartDate : action.payload.oldWeeklyStartDate,
                newWeeklyEndDate : action.payload.newWeeklyEndDate,
                oldWeeklyEndDate : action.payload.oldWeeklyEndDate
            }
        case SET_RAW_DATE_HANDLER:
            return {
                ...state,
                rawDateError: action.payload.rawDateError,
                invalidDate: action.payload.invalidDate
            }
        case SET_RAW_DATE:
            return {
                ...state,
                rawDateError: action.payload.rawDateError
            }
        default : 
            return state;        
    }
}